module.exports = __webpack_public_path__ + "static/media/dragIcon.f38e0629.svg";